<template>
    <header-index />
    <!-- 面包屑导航 -->
    <div class="px-4 h-[60px] leading-[60px]" style="background-color: rgb(245, 245, 245);">
        <div class="flex mx-auto items-center text-sm mb-6 leading-[60px] container max-auto">

            <nuxt-link to="/" class="text-gray-500 hover:text-green-600">
                <span class="icon-home mr-1"></span> Home
            </nuxt-link>
            <span class="mx-2 text-gray-500">></span>
            <nuxt-link to="/packaging" class="text-gray-500 hover:text-green-600">Packaging</nuxt-link>
            <span class="mx-2 text-gray-500">></span>
            <span class="text-gray-700">Contact us</span>
        </div>
    </div>
    <div class="container mx-auto py-8 px-4">
        <div class="flex flex-col lg:flex-row gap-8">
            <!-- 左侧内容 -->
            <div class="w-full lg:w-1/2">
                <h1 class="text-3xl font-weight-600 text-green-600 mb-2">Custom Packaging</h1>
                <h2 class="text-2xl font-weight-600 text-green-600 mb-4">Supply Chain Manufacturer</h2>

                <p class="text-gray-700 mb-8">
                    Any company that needs to beat their rival needs to have a highly
                    capable packaging company besides them offering them the most
                    meaningful and cost-effective solutions to all their preferences
                    and needs.
                </p>

                <!-- FAQ 部分 -->
                <div class="bg-white p-6 shadow-md rounded-md">
                    <h3 class="text-xl font-weight-600d mb-4">Frequently Asked Questions</h3>

                    <div class="space-y-4">
                        <div 
                            v-for="(faq, index) in faqItems" 
                            :key="faq.question" 
                            class="border-b border-gray-200 pb-3"
                        >
                            <button 
                                type="button" 
                                class="flex w-full items-center justify-between cursor-pointer py-2 text-left hover:text-green-600 focus:outline-none"
                                @click="toggleFaq(index)"
                            >
                                <div class="flex items-center">
                                    <span class="text-green-600 mr-2 text-xl font-weight-600">
                                        {{ faq.isOpen ? '-' : '+' }}
                                    </span>
                                    <p class="text-gray-800">{{ faq.question }}</p>
                                </div>
                            </button>

                            <transition name="faq-fade">
                                <div v-if="faq.isOpen" class="faq-content mt-2 pl-8 text-gray-600">
                                    <p class="text-sm leading-relaxed" v-html="faq.answer"></p>
                                </div>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 右侧表单 -->
            <div class="w-full lg:w-1/2">
                <div class="bg-white p-6 shadow-md rounded-md">
                    <h2 class="text-xl font-weight-600 mb-4">REQUEST A QUOTE</h2>
                    <p class="text-gray-600 text-sm mb-6">
                        Complete our quote request form or email us at sales@leaflypackaging.com to receive a customized quote from
                        our product specialists.
                    </p>

                    <form @submit.prevent="submitForm" class="space-y-4">
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div class="form-group">
                                <label class="block text-sm font-weight-400 mb-1">Contact Name*</label>
                                <input type="text" v-model="formData.contactName" class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500" required>
                            </div>

                            <div class="form-group">
                                <label class="block text-sm font-weight-400 mb-1">Email Address*</label>
                                <input
                                    type="email"
                                    v-model="formData.email"
                                    class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                                    required
                                    :class="{'border-red-500': emailError}"
                                    @blur="validateEmail"
                                >
                                <p v-if="emailError" class="text-red-500 text-sm mt-1">Please enter a valid email address.</p>
                            </div>

                            <div class="form-group">
                                <label class="block text-sm font-weight-400 mb-1">Phone Number (Option)</label>
                                <input
                                    type="tel"
                                    v-model="formData.phoneNumber"
                                    class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                                    :class="{'border-red-500': phoneError}"
                                    @blur="validatePhone"
                                >
                                <p v-if="phoneError" class="text-red-500 text-sm mt-1">Please enter a valid phone number.</p>
                            </div>

                            <div class="form-group">
                                <label class="block text-sm font-weight-400 mb-1">Zip Code (Option)</label>
                                <input
                                    type="text"
                                    v-model="formData.zipCode"
                                    class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                                    :class="{'border-red-500': zipCodeError}"
                                    @blur="validateZipCode"
                                >
                                <p v-if="zipCodeError" class="text-red-500 text-sm mt-1">
                                    Please enter a valid zip code.
                                    <span class=" mt-1">Format: 12345 or 12345-6789</span>
                                </p>
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="block text-sm font-weight-400 mb-1">Company Name (Option)</label>
                            <input type="text" v-model="formData.companyName" class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500">
                        </div>

                        <div class="form-group">
                            <label class="block text-sm font-weight-400 mb-1">Product*</label>
                            <select v-model="formData.product" class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                                :class="{ 'text-gray-400': !formData.product, 'text-black': formData.product }" required>
                                <option value="" disabled>Select a product</option>
                                <option value="boxes">Custom Boxes</option>
                                <option value="bags">Custom Bags</option>
                                <option value="labels">Custom Labels</option>
                                <option value="jars">Custom Jars</option>
                                <option value="tubes">Custom Tubes</option>
                                <option value="tins">Custom Tins</option>
                                <option value="other">Other Products</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label class="block text-sm font-weight-400 mb-1">File Upload:</label>
                            <div class="border border-dashed border-gray-300 rounded p-4 text-center cursor-pointer hover:bg-gray-50 file-upload-container" @click="triggerFileInput">
                                <div class="flex items-center justify-center">
                                    <span class="text-blue-500">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                                        </svg>
                                    </span>
                                </div>
                                <p class="text-sm text-gray-500 mt-2">Support uploading design source files in AI/PDF format, or screenshots of the design files</p>
                                <input type="file" ref="fileInput" class="hidden" @change="handleFileChange" multiple>
                                <div v-if="formData.files.length > 0" class="mt-2 text-left">
                                    <p v-for="(file, index) in formData.files" :key="index" class="text-sm text-gray-700">
                                        {{ file.name }} ({{ formatFileSize(file.size) }})
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="block text-sm font-weight-400 mb-1">Please describe your project</label>
                            <textarea v-model="formData.message" class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500 placeholder:text-gray-400"
                                rows="5"
                                placeholder="Please provide details on the box style you are looking for, the dimensions, and whether you want printing inside, outside, or both. Additionally, feel free to share any other details or specific requirements that will help us better understand your project."
                            ></textarea>
                        </div>

                        <div class="flex space-x-4">
                            <button
                                type="submit"
                                :disabled="submitting"
                                :class="submitting
                                    ? 'bg-green-400 cursor-not-allowed'
                                    : 'bg-green-600 hover:bg-green-700'"
                                class="text-white py-2 px-6 rounded transition duration-200 disabled:opacity-70"
                            >
                                {{ submitting ? 'Waiting...' : 'Submit' }}
                            </button>
                            <button type="button" @click="resetForm" :disabled="submitting" class="bg-gray-300 hover:bg-gray-400 text-gray-800 py-2 px-6 rounded transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed">
                                Reset
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <!-- Toast 消息 -->
    <toast-message ref="toastMessageRef" />

    <footer-index />
</template>

<script setup lang="ts" name="SinglePageContactUs">
    import type { SinglePage, Response } from '~/types';
    import headerIndex from '../../components/header/header-index.vue'
    import footerIndex from '../../components/footer/footer-index.vue'
    import toastMessage from '../../components/common/toastMessage.vue'

    import { useHttp } from '~/utils/httpUtil'
    import { ref } from 'vue'


    const cmsInfo = await cmsUtils.getCmsInfo();
    const route = useRoute()
    const props = defineProps<{
        singlePage: SinglePage
    }>()

    const fileInput = ref<HTMLInputElement | null>(null)
    // Toast 状态
    const toastMessageRef = ref<InstanceType<typeof toastMessage> | null>(null)
    // Phone validation
    const phoneError = ref(false)
    // Email validation
    const emailError = ref(false)
    // Zip code validation
    const zipCodeError = ref(false)
    // 提交中状态：防止重复提交，按钮置灰 + 文案变为 Waiting...
    const submitting = ref(false)

    const formData = ref({
        contactName: '',
        email: '',
        phoneNumber: '',
        zipCode: '',
        companyName: '',
        product: '',
        files: [] as File[],
        message: ''
    })

    function resetForm() {
        formData.value.contactName = ''
        formData.value.email = ''
        formData.value.phoneNumber = ''
        formData.value.zipCode = ''
        formData.value.companyName = ''
        formData.value.product = ''
        formData.value.files = []
        formData.value.message = ''
    }

    function triggerFileInput() {
        if (fileInput.value) {
            fileInput.value.click()
        }
    }

    function handleFileChange(event: Event) {
        const input = event.target as HTMLInputElement
        if (input.files && input.files.length > 0) {
            const files = Array.from(input.files)
            formData.value.files = [...formData.value.files, ...files]
        }
    }

    function formatFileSize(size: number) {
        if (size < 1024) {
            return size + ' bytes'
        } else if (size < 1024 * 1024) {
            return (size / 1024).toFixed(2) + ' KB'
        } else {
            return (size / (1024 * 1024)).toFixed(2) + ' MB'
        }
    }

    function validateEmail() {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        emailError.value = !emailRegex.test(formData.value.email)
    }

    function validatePhone() {
        // 手机号是可选字段，为空时通过校验；非空时校验格式（只允许数字、+、(、) 和空格，与后端一致）
        if (formData.value.phoneNumber.trim() === '') {
            phoneError.value = false
            return
        }
        const phoneRegex = /^[\+]?[1-9][\d\-]{0,15}$/
        phoneError.value = !phoneRegex.test(formData.value.phoneNumber.replace(/[\s\-\(\)]/g, ''))
    }

    function validateZipCode() {
        // 邮编是可选字段，为空时通过校验；非空时校验格式
        if (formData.value.zipCode.trim() === '') {
            zipCodeError.value = false
            return
        }
        const zipRegex = /^\d{5}(-\d{4})?$/
        zipCodeError.value = !zipRegex.test(formData.value.zipCode.trim())
    }

    interface ContactFaqItem {
        question: string
        answer: string
        isOpen: boolean
    }

    const faqItems = ref<ContactFaqItem[]>([
        {
            question: 'What is your minimum order quantities (MOQ)?',
            answer: 'Our minimum order quantities vary depending on the product type and customization requirements. Please contact us with your specific project details so we can provide an accurate MOQ recommendation.',
            isOpen: false
        },
        {
            question: 'What is the turnaround time on my order?',
            answer: 'Standard turnaround time is typically 2-3 weeks after artwork approval. Rush options may be available for an additional fee depending on the production schedule.',
            isOpen: false
        },
        {
            question: 'Where do you ship to?',
            answer: 'We ship globally with various shipping options available depending on your location and requirements. International deliveries typically range from 7-21 business days.',
            isOpen: false
        },
        {
            question: 'Do you have volume discounts or price breaks?',
            answer: 'Yes, we offer competitive volume discounts on larger orders. Please share your quantity requirements so we can provide tiered pricing options tailored to your needs.',
            isOpen: false
        },
        {
            question: 'Do you offer rush orders?',
            answer: 'Rush orders are available for qualifying products. Let us know your target date and we will confirm expedited production and shipping availability.',
            isOpen: false
        },
        {
            question: 'How do I place a reorder?',
            answer: 'You can place a reorder by logging into your account or by contacting our customer service team with your previous order details. We keep your dielines and artwork on file for hassle-free reorders.',
            isOpen: false
        },
        {
            question: 'I have more questions',
            answer: 'Our packaging specialists are happy to help. Email us at <a href="mailto:sales@leaflypackaging.com" class="text-green-600 hover:underline">sales@leaflypackaging.com</a> or call (+86) 158 1559 7437 for dedicated support.',
            isOpen: false
        }
    ])

    const baseUrl = (cmsInfo.website.https ? 'https://' : 'http://') + cmsInfo.website.domain
    const canonicalUrl = baseUrl + route.path.replace('.html','')
    useHead({
        script: [
            {
                type: 'application/ld+json',
                innerHTML: JSON.stringify({
                    '@context': 'https://schema.org',
                    '@type': 'ContactPage',
                    name: props.singlePage.title,
                    description: props.singlePage.description,
                    url: canonicalUrl,
                    mainEntity: [
                        {
                            '@type': 'Organization',
                            name: cmsInfo.website.title,
                            url: baseUrl,
                            contactPoint: {
                                '@type': 'ContactPoint',
                                email: 'sales@leaflypackaging.com',
                                telephone: '+86-158-1559-7437',
                                contactType: 'customer service',
                                availableLanguage: ['English']
                            }
                        },
                        {
                            '@type': 'FAQPage',
                            mainEntity: faqItems.value.map(faq => ({
                                '@type': 'Question',
                                name: faq.question,
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: faq.answer.replace(/<[^>]*>/g, '')
                                }
                            }))
                        }
                    ]
                })
            }
        ]
    })

    const toggleFaq = (index: number) => {
        if (index < 0 || index >= faqItems.value.length) return
        const targetFaq = faqItems.value[index]
        if (targetFaq) {
            targetFaq.isOpen = !targetFaq.isOpen
        }
    }

    async function submitForm() {
        // 防止重复提交
        if (submitting.value) return
        submitting.value = true

        // 校验所有字段
        validateEmail()
        validatePhone()
        validateZipCode()
        if (emailError.value || phoneError.value || zipCodeError.value) {
            toastMessageRef.value?.showFail('Please correct the errors in the form.')
            submitting.value = false
            return
        }

        // 创建FormData对象用于文件上传
        const formDataObj = new FormData()
        formDataObj.append('contactName', formData.value.contactName)
        formDataObj.append('email', formData.value.email)
        formDataObj.append('phoneNumber', formData.value.phoneNumber)
        formDataObj.append('zipCode', formData.value.zipCode)
        formDataObj.append('companyName', formData.value.companyName)
        formDataObj.append('product', formData.value.product)
        formDataObj.append('message', formData.value.message)
        formDataObj.append('token', await generateToken(cmsInfo.website.id.toString(),timestampStr))
        formDataObj.append('websiteId', cmsInfo.website.id.toString())
        formDataObj.append('timestamp', timestampStr)
        formDataObj.append('randomStr', randomStr)
        // 来源页面 URL（用于追溯留言提交位置）
        formDataObj.append('sourceUrl', typeof window !== 'undefined' ? window.location.href : '')
        // 添加文件
        formData.value.files.forEach((file, index) => {
            formDataObj.append(`file`, file)
        })

        try {
            const res = await useHttp("/nuxt/common/addUserConsultant", {
                method: 'POST',
                body: formDataObj,
                // 使用FormData时不要设置Content-Type，浏览器会自动设置正确的类型
                headers: {
                    // 移除Content-Type让浏览器自动设置
                }
            }) as Response<any>
            toastMessageRef.value?.showSuccess('Thank you for your inquiry! We will reply to you as soon as possible!')
            resetForm()

        } catch (error:any) {
            console.log('........error = ', error )
            toastMessageRef.value?.showFail(error.msg);
        } finally {
            submitting.value = false
        }
    }

    let res = await useHttp("/nuxt/common/getTimestamp", {
        method: 'POST',
        body: {},
        // 使用FormData时不要设置Content-Type，浏览器会自动设置正确的类型
        headers: {
            // 移除Content-Type让浏览器自动设置
        }
    }) as Response<string>
    const timestampStr = res.data
    let randomStr = ''

    // 生成 Token
    async function generateToken(websiteIdStr: string,timestampStr: string) {
        let randomArray = new Uint8Array(16);
        window.crypto.getRandomValues(randomArray);
        randomStr = Array.from(randomArray).map(b => b.toString(16).padStart(2, '0')).join('');
        const data = `${websiteIdStr}:${timestampStr}:${randomStr}`;

        // 使用 Web Crypto API 计算哈希
        const hash = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(data))
        const hashArray = Array.from(new Uint8Array(hash));
        const token = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
        return token;
    }

</script>

<style scoped lang='scss'>
    .container{
        min-height:1050px;
    }
    .icon-home {
        display: inline-block;
        width: 14px;
        height: 14px;
        background-size: contain;
        background-repeat: no-repeat;
        vertical-align: middle;
    }

    .file-upload-container {
        transition: all 0.3s ease;

        &:hover {
            border-color: #059669;
        }
    }

    /* Required field indicator */
    .form-group label::after {
        content: '';
    }

    .form-group label[for]:not([for="companyName"])::after {
        content: '*';
        color: #e53e3e;
        margin-left: 2px;
    }

    .faq-content {
        line-height: 1.6;
    }

    .faq-fade-enter-active,
    .faq-fade-leave-active {
        transition: all 0.3s ease;
    }

    .faq-fade-enter-from,
    .faq-fade-leave-to {
        opacity: 0;
        transform: translateY(-4px);
    }
</style>
